module.exports = __webpack_public_path__ + "static/img/13.f89c107.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/13.png
// module id = nfdC
// module chunks = 0